import { Card } from '@ui/themed';
import { t } from 'i18next';
import { I18N_PAGE } from '../constants';
import type { Customer } from '../types';
import { DetailGrid } from './detail-grid';

export function CustomerSummaryCard({ customer }: { customer: Customer }) {
  return (
    <Card>
      <Card.Header headingLevel="h2">{t(`${I18N_PAGE}.summary.title`)}</Card.Header>
      <Card.Body>
        <DetailGrid
          details={{
            [t(`${I18N_PAGE}.summary.full_name`)]: `${customer.first_name} ${customer.last_name}`,
            [t(`${I18N_PAGE}.summary.email`)]: customer.email,
            [t(`${I18N_PAGE}.summary.external_id`)]: customer.external_id ?? '',
            [t(`${I18N_PAGE}.summary.internal_id`)]: customer.id,
          }}
        />
      </Card.Body>
    </Card>
  );
}
